var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warehouse-list"},[_c('Table',{staticClass:"margin-15",attrs:{"max-height":"400","size":"small","border":"","columns":_vm.columns,"data":_vm.warehouseList}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }